import { useIdleTimer } from 'react-idle-timer'
import { useEffect } from 'react'
import { setDataAttribute } from '@/utils/dom.utils'
import { useOurStore } from '@/app/_providers/StoreProvider'

export const DATA_ATTR_NAME = 'data-idle'
// milliseconds till we consider a user idle: 25 minutes
export const IDLE_TIMEOUT = 1.5e+6

const useIdleTimerTool = (): void => {
  const updatePartial = useOurStore((state) => state.updatePartial)
  const onIdle = (): void => {
    updatePartial({ userIsIdle: true })
    setDataAttribute(document.body, DATA_ATTR_NAME, 'true')
  }

  const onActive = (): void => {
    updatePartial({ userIsIdle: false })
    setDataAttribute(document.body, DATA_ATTR_NAME, 'false')
  }

  useEffect(() => {
    // set initial data-idle state
    setDataAttribute(document.body, DATA_ATTR_NAME, 'false')
  }, [])

  useIdleTimer({
    onIdle,
    onActive,
    timeout: IDLE_TIMEOUT,
    throttle: 500,
  })
}

export default useIdleTimerTool
